/**
 * Created by fers on 27.04.16.
 */
import React from 'react';
import PropTypes from 'prop-types';
import DropColumn from './JSONTableDropTable.react';
import DropRow from './JSONTableDropRow.react';
import DragColumn from './JSONTableDragColumn.react';
import { DropTarget } from 'react-dnd';
import { FormControl, Form, FormGroup, HelpBlock, ControlLabel } from 'react-bootstrap';
import {injectIntl, defineMessages, FormattedMessage, IntlShape} from 'react-intl';
import {Collapse} from 'react-collapse';
import JsontableNew from './JSONTableNew.react';
import {Grid} from '../../../fw/Grid.react';
import {ParentTemplate} from '../../box-utils/ParentTemplate.react.js';
import JsonEmptyTable from './JSONTableDropEmpty.react';
import config from '../../../../common/config';
import {safeJSONparse} from '../../../../common/util/safeJSONparse';

import './JSONTable.scss';

const messages = defineMessages({
    filterPlaceholder: {id: 'jsonTable.settins.filterPlaceholder', 'defaultMessage': 'Filter available columns'},
    channel: {id: 'jsonTable.settins.channel', 'defaultMessage': '{productName} Application'},
    organisation: {id: 'jsonTable.settins.organisation', 'defaultMessage': '{productName} Organisation'},
});


export const JSON_TABLE_LAST = 'last';

export let tableInstacne = null;
class JSONTableProvider extends ParentTemplate {

    static propTypes = {
		connectDropTarget: PropTypes.func.isRequired,
		dataSources: PropTypes.array,
		fieldDefs: PropTypes.array,
		intl: PropTypes.object.isRequired,
		isDetailView: PropTypes.bool,
		isOver: PropTypes.bool.isRequired,
		onChange: PropTypes.func,
		viewWithData: PropTypes.object,
		widgetConfigView: PropTypes.bool,
    };

	static defaultProps = {
		widgetConfigView: false,
	};

	constructor(props) {
		super(props);

		// used as a closure for passed functions and prevent their properties change on this stage change
		tableInstacne = this; // eslint-disable-line consistent-this

		this.allColumns = JSONTableProvider.createColumnOffer(props);

		let columns = JsontableNew.getColumnsFromViewDefStatic(props, false);
		let keys = Object.keys(columns);

		this.isGroupView = Boolean(props.dataSources);

		this.state = {
			columnIndexArray: keys,
			columns: columns,
			columnOffer: JSONTableProvider.createColumnOffer(props, keys),
			collapsed: [],
			draggingColumnData: {},
			draggingColumnIndex: null,
			order: JSONTableProvider.getOrder(props),
			viewWithData: props.viewWithData,
			rows: JsontableNew.getLimit(props.viewWithData),
			search: '',
		};
	}

	static sortColumnsFunction(column1, column2) {
		return column1.fieldDef.name.localeCompare(column2.fieldDef.name);
	}

	static createColumnOffer(props, columnsInTableArray = []) {
        let appendColumns = [
            {
                fieldDef: {
                    realId: 'channel',
                    name: props.intl.formatMessage(messages.channel, {productName: config.PRODUCT_NAME}),
                }
            },
            {
                fieldDef: {
                    realId: 'organisation',
                    name: props.intl.formatMessage(messages.organisation, {productName: config.PRODUCT_NAME}),
                }
            }
        ];

		if (props.fieldDefs) {
			let columns = JSONTableProvider.sortColumnOffer(props.fieldDefs);
			if (columnsInTableArray.length === 0) {
				return columns;
			}
			return [...columns.filter(column => -1 === columnsInTableArray.indexOf(column.fieldDef.realId)), ...appendColumns];
		}

		if (props.dataSources) {
			return props.dataSources.map((dataSource, dataSourceIdx) => {
				let columns = JSONTableProvider.sortColumnOffer(dataSource.fields);

				// remove duplicities from columns object
				columns.filter((column, idx) => idx === columns.findIndex(item => item.fieldDef.realId === column.fieldDef.realId));

				if (columnsInTableArray.length !== 0) {
					columns = columns.filter(column => -1 === columnsInTableArray.indexOf(column.fieldDef.realId));
				}

				return {
					realId: dataSource.realId,
					fields: [...columns, ...appendColumns],
					title: dataSource.title,
				};
			});
		}
	}

	static getOrder(props) {
		if (props.viewWithData.entityDef.entityViewDef) {
			return safeJSONparse(props.viewWithData.entityDef.entityViewDef.order);
		}

		return [];
	}

	getSaveData(data) {
		data['order'] = this.state.order;
		data['filter'] = {
			limit: this.state.rows
		};

		let template = [];

		this.state.columnIndexArray.forEach(columnId => {
			let column = this.state.columns[columnId];
			let colObject = {
				id: columnId
			};
			if (column.name) {
				colObject.name = column.name;
			}
			template.push(colObject);
		});
		data['template'] = JSON.stringify(template);

		return data;
	}

	draggingFn(dragItem, targetIndex, originalIndex) {
		let columns = tableInstacne.state.columns;
		let columnIndexArray = tableInstacne.state.columnIndexArray;

		// beware of zero index
		if (originalIndex !== undefined && -1 !== columnIndexArray.indexOf(dragItem.column.id)) {
			delete columns[columnIndexArray[originalIndex]];
			columnIndexArray.splice(originalIndex, 1);
		}

		if (targetIndex !== tableInstacne.state.draggingColumnIndex) {
			tableInstacne.setState({
				columns: columns,
				columnIndexArray: columnIndexArray,
				draggingColumnData: dragItem,
				draggingColumnIndex: targetIndex,
			});
		}
	}

	static sortColumnOffer(columnOffer, isGroupView) {
		if (isGroupView) {
			columnOffer.forEach(dataSource => {
				dataSource.fields.sort(JSONTableProvider.sortColumnsFunction);
			});
		}
		else {
			columnOffer = columnOffer.sort(JSONTableProvider.sortColumnsFunction);
		}

		return columnOffer;
	}

	static findColumn(columns, realId, isGroupView) {
		if (isGroupView) {
			let col;
			columns.find(dataSource => {
				col = dataSource.fields.find(column => realId === column.fieldDef.realId);
				if (col) {
					return true;
				}
			});

			return col;
		}

		return columns.find(column => {
			if (Boolean(column)) {
				return realId === column.fieldDef.realId;
			}
			return false;
		});
	}

	static addColumnToColumnsOffer(columnOffer, column, isGroupView) {
		if (isGroupView) {
			columnOffer[column.dataSourceIdx].fields.push(column);
		}
		else {
			columnOffer.push(column);
		}
		return JSONTableProvider.sortColumnOffer(columnOffer, isGroupView);
	}

	removeColumn(index) {
		let columnOffer = tableInstacne.state.columnOffer;
		let columnIndexArray = tableInstacne.state.columnIndexArray;

		let columnId = columnIndexArray[index];
		let col = JSONTableProvider.findColumn(tableInstacne.allColumns, columnId, tableInstacne.isGroupView);

		if (col) {
			columnOffer = JSONTableProvider.addColumnToColumnsOffer(columnOffer, col, this.isGroupView);
		}

		columnIndexArray.splice(index, 1);

		delete tableInstacne.state.columns[columnId];

		let order = tableInstacne.state.order;
		if (order && order.length > 0 && order[0].column === columnId) {
			order = [{
				column: columnIndexArray[0],
				asc: true
			}];
		}

		tableInstacne.setState({
			columnIndexArray: columnIndexArray,
			columns: tableInstacne.state.columns,
			columnOffer: columnOffer,
			draggingColumnData: {},
			draggingColumnIndex: null,
			order: order,
		});

		if (tableInstacne.props.onChange) {
			tableInstacne.props.onChange();
		}
	}

	dragEndFn() {
		if (tableInstacne.state.draggingColumnIndex === null) {
			return;
		}

		let columnOffer = safeJSONparse(JSON.stringify(tableInstacne.state.columnOffer));

		if (columnOffer.length && columnOffer.fields) {
			columnOffer.fields.push(tableInstacne.state.draggingColumnData.column);
		}
		else {
			columnOffer.push(tableInstacne.state.draggingColumnData.column);
		}

		tableInstacne.setState({
			columnOffer: columnOffer,
			draggingColumnData: {},
			draggingColumnIndex: null,
		});
	}

	dropFn(dropItem, targetIndex) {
		if (targetIndex === JSON_TABLE_LAST) {
			targetIndex = tableInstacne.state.columnIndexArray.length;
		}
		let columnId = dropItem.column.realId || dropItem.column.id;
		tableInstacne.state.columnIndexArray.splice(targetIndex, 0, columnId);

		let colObject = {};
		colObject[columnId] = {};

		let columns = tableInstacne.state.columns;
		columns[columnId] = {};

		let columnOffer = tableInstacne.state.columnOffer.filter(column => (columnId !== column.realId || columnId !== column.fieldDef.realId));

		tableInstacne.state.columnOffer.forEach(item => {
			item.fields = (item.fields || []).filter(field => (columnId !== field.fieldDef.realId));
		});

		tableInstacne.setState({
			columnIndexArray: tableInstacne.state.columnIndexArray,
			columns: columns,
			columnOffer: columnOffer,
			draggingColumnData: {},
			draggingColumnIndex: null,
		});

		if (tableInstacne.props.onChange) {
			tableInstacne.props.onChange();
		}
	}

	addDraggingColumn(columns) {
		if (this.state.draggingColumnIndex !== null) {
			let column = this.state.draggingColumnData.column;
			let columnObject = {};
			let id = column.realId || column.id;
			columnObject[id] = {};

			let columnMap;
			if (column.invalid) {
				columnMap = [column];
			}
			else {
				columnMap = Grid.getColumnsForMap(columnObject, this.getMetaData().fields());
			}
			columnMap.dragging = true;

			columns.splice(this.state.draggingColumnIndex, 0, columnMap[0]);
		}

		return columns;
	}

	changeRowsCnt(event) {
		this.setState({
			rows: event.target.value
		});
	}

	getValidationState() {
		let rows = parseInt(this.state.rows, 10);

		if (!rows || rows < 1 || rows > 200) {
			return 'error';
		}

		return null;
	}

	searchColumnOffer(event) {
		this.setState({
			search: event.target.value,
			collapsed: [], // expand all gorups on search to see the results
		});
	}

	orderChange(newOrder) {
		tableInstacne.setState({
			order: newOrder
		});
	}

	renameColumn(columnId, name) {
		let columns = tableInstacne.state.columns;
		columns[columnId].name = name;

		tableInstacne.setState({
			columns: columns
		});
	}

    render() {
		let columns = Grid.getColumnsForMap(this.state.columns, this.getMetaData().fields(), this.state.columnIndexArray, this.props.widgetConfigView);
		this.addDraggingColumn(columns);
		let columnWidth = 100 / columns.length;
		let rows = this.state.rows === '' ? this.rows : parseInt(this.state.rows, 10);
		this.rows = rows || 5;

		return (
			<div className="jsonTableConfigWrapper">
				{this.renderColumnsOffer()}
				<div className={"targetConfigJsonTable" + (this.props.isDetailView ? ' detailView' : '')}>
					{
						columns.length === 0
						? <JsonEmptyTable draggingFn={this.draggingFn} dropFn={this.dropFn} isDetailView={this.props.isDetailView} />
						: columns.map((column, idx) => {
							let props = {
								column: column,
								columnOffer: this.allColumns,
								dragEndFn: this.dragEndFn,
								draggingIndex: this.state.draggingColumnIndex,
								draggingFn: this.draggingFn,
								dropFn: this.dropFn,
								index: idx,
								isGroupView: this.isGroupView,
								order: this.state.order,
								orderChange: this.orderChange,
								width: columnWidth,
								removeColumn: this.removeColumn,
								renameColumn: this.renameColumn,
								rows: rows,
								viewWithData: this.state.viewWithData,
							};

							if (this.props.isDetailView) {
								return (<DropRow {...props} key={column.id} />);
							}
							return (<DropColumn {...props} key={column.id} />);
						})
					}
				</div>
			</div>
		);
    }

	getRenderedColumns(columns, searchValue) {
		if (columns === undefined) {
			return null;
		}

		return columns
			.filter(column => column !== null)
			.map((column, idx) => {
				if (!column.fieldDef) {
					return null;
				}
				if (this.state.search !== '' && -1 === column.fieldDef.name.toLowerCase().indexOf(searchValue)) {
					return null;
				}
				return (<DragColumn column={column.fieldDef} dragEndFn={this.dragEndFn} dropFn={this.dropFn} key={column.dataSourceIdx + '|' + column.fieldDef.name + '|' + column.fieldDef.realId} searchValue={searchValue} />);
			})
			.filter(column => column !== null);
	}

	toggleColumns(e) {
		let idx = safeJSONparse(e.target.closest('h4').getAttribute('data')).idx;
		let collapsed = this.state.collapsed;
		let isCollapsed = collapsed.findIndex(item => item === idx);

		if (isCollapsed === -1) {
			collapsed.push(idx);
		}
		else {
			collapsed.splice(isCollapsed, 1);
		}

		this.setState({
			collapsed: collapsed
		});
	}

	getRenderedColumnsWrapper() {
		let searchValue = this.state.search.toLowerCase();

		if (this.isGroupView) {
			let self = this;
			let isSingleGroup = 1 === this.state.columnOffer.length;

			return this.state.columnOffer.map((dataSource, idx) => {
				let columns = self.getRenderedColumns(dataSource.fields, searchValue);
				let isCollapsed = -1 !== self.state.collapsed.findIndex(item => item === idx);

				// don't display empty data sources eg. while filtering
				if (!columns || !columns.length || columns.length === 0) {
					return null;
				}

				let columnOffer = self.getRenderedColumns(dataSource.fields, searchValue);

				if (isSingleGroup) {
					return columnOffer;
				}

				return (
					<div className={"columnSettingsGroup " + (isCollapsed ? 'collapsed' : 'expanded')} key={idx}>
						<h4 data={JSON.stringify({idx: idx})} onClick={self.toggleColumns.bind(self)}>{dataSource.title}<span className="flex"></span><i className="fa fa-chevron-down"></i></h4>
						<Collapse isOpened={!isCollapsed}>
							{columnOffer}
						</Collapse>
					</div>
				);
			}).filter(dataSource => dataSource !== null);
		}

		return this.getRenderedColumns(this.state.columnOffer, searchValue);
	}

	renderColumnsOffer() {
		let availableColumns = this.state.columnOffer.length > 0;
		let columnOffer = this.getRenderedColumnsWrapper();

		let height = window.innerHeight - 1150;
		if (height < 400) {
			height = 400;
		}

		return (
			<div className="columnsOffer">
				<strong>
					{
						this.props.isDetailView
						? <FormattedMessage defaultMessage="Available columns:" id="jsonTable.settings.availableColumns" />
						: <FormattedMessage defaultMessage="Available rows:" id="jsonTable.settings.availableRows" />
					}
				</strong>
				<Form className="search">
					<FormControl onChange={this.searchColumnOffer.bind(this)} placeholder={this.props.intl.formatMessage(messages.filterPlaceholder)} type="text" value={this.state.search} />
					<FormControl.Feedback>
						<i className="fa fa-search"></i>
					</FormControl.Feedback>
				</Form>
				<div className="columnsToDrag" style={{maxHeight: height + 'px'}}>
					{availableColumns
						? (columnOffer.length
							? columnOffer
							: (<span className="noNextColumn"><FormattedMessage defaultMessage="Empty filter result" id="jsonTable.config.emptyFilter" /></span>)
						)
						: (<span className="noNextColumn"><FormattedMessage defaultMessage="No other column available" id="jsonTable.config.outOfColumns" /></span>)
					}
				</div>
				<Form className="columnSettings">
					<FormGroup controlId="formBasicText" validationState={this.getValidationState()}>
						<ControlLabel>
							{
								this.props.isDetailView
								? <FormattedMessage defaultMessage="Maximum visible rows:" id="jsonTable.config.rowsCount" />
								: <FormattedMessage defaultMessage="Maximum visible items:" id="jsonTable.config.itemsCount" />
							}
						</ControlLabel>
						<FormControl onChange={this.changeRowsCnt.bind(this)} type="text" value={String(this.state.rows)} />
						<HelpBlock><FormattedMessage defaultMessage="Minimum 1, maximum 200" id="jsonTable.settings.rowsLimit" /></HelpBlock>
					</FormGroup>
				</Form>
			</div>
		);
	}
}


function dropActions(connect, monitor) {
	return {
		connectDropTarget: connect.dropTarget(),
		isOver: monitor.isOver(),
	};
}

export default injectIntl(DropTarget('JSONTableDragColumn', {}, dropActions)(JSONTableProvider));
